import { z } from 'zod';
import { PROJECT_STATUSES } from '../enums.js';
import { objectId, paginationQuery, scopeQuery } from './common.js';
const projectFields = {
    code: z.string().trim().min(1).max(30).toUpperCase(),
    name: z.string().trim().min(2).max(160),
    description: z.string().trim().max(1000).optional().or(z.literal('')),
    status: z.enum(PROJECT_STATUSES).default('ACTIVE'),
};
export const createProjectRequest = z.object({
    companyId: objectId,
    ...projectFields,
});
export const updateProjectRequest = z.object({
    code: projectFields.code.optional(),
    name: projectFields.name.optional(),
    description: projectFields.description,
    status: z.enum(PROJECT_STATUSES).optional(),
});
export const projectListQuery = paginationQuery.merge(scopeQuery).extend({
    status: z.enum(PROJECT_STATUSES).optional(),
});
export const updateProjectEmployeesRequest = z.object({
    employeeIds: z
        .array(objectId)
        .max(1000)
        .refine((ids) => new Set(ids).size === ids.length, 'An employee can only be listed once'),
});
//# sourceMappingURL=project.js.map